import { render, staticRenderFns } from "./Locations.vue?vue&type=template&id=65cc8204&scoped=true&lang=pug"
import script from "./Locations.vue?vue&type=script&lang=js"
export * from "./Locations.vue?vue&type=script&lang=js"
import style0 from "./Locations.vue?vue&type=style&index=0&id=65cc8204&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65cc8204",
  null
  
)

export default component.exports